import React from "react";

export const Arrived: React.FC = () => {
  return (
    <div id="arrived" className="arrived-container">
      <img 
        src="img/img1.webp" 
        alt="Endocomunidad" 
        className="arrived-image"
      />
      <div className="arrived-text-overlay">
        <h2 className="arrived-title">LLEGÓ EL MOMENTO DE HABLAR DE</h2>
        <h1 className="arrived-subtitle">LO QUE NOS INCOMODA</h1>
      </div>
    </div>
  );
};

